import React, { useEffect, useState } from 'react'
import { validateFunctionalForm } from '../../../utils';
import { v3_all_countries, v3_all_states } from '../../../actions/v3/masterData';

const Form = (props) => {
    const [state, setState] = useState({
        country: { name: 'country', value: props.data ? props.data.COUNTRY_ID : '', options: [], isRequired: true, error: '' },
        state: { name: 'state', value: props.data ? props.data.STATE_ID : '', options: [], isRequired: true, error: '' },
        name: { name: 'name', value: props.data ? props.data.NAME : '', isRequired: true, error: '' },
        otherDetails: { name: 'otherDetails', value: props.data ? props.data.DETAIL : '', isRequired: false, error: '' },
    })
    const onChange = (e) => {
        const { name, value } = e.target;
        setState(prevState => ({
            ...prevState,
            [name]: {
                ...prevState[name],
                value: value,
                error: prevState[name].isRequired && !value ? 'This field is required' : ''
            }
        }));
    };

    const setOptions = (name, options) => {
        setState(prevState => ({
            ...prevState,
            [name]: {
                ...prevState[name],
                options: options
            }
        }));
    };

    useEffect(() => {

        v3_all_countries().then((res) => {
            if (res.status) {
                setOptions('country', res.result)
            }
            else {

            }
        })
    }, [])
    useEffect(() => {
        if (state.country.value)
            v3_all_states(state.country.value).then((res) => {
                if (res.status) {
                    setOptions('state', res.result)
                }
                else {

                }
            })
    }, [state.country.value])

    const onSubmit = (e) => {
        e.preventDefault();
        if (validateFunctionalForm(state, setState)) {
            const model = {
                country: state.country.value,
                district: state.name.value,
                districtDetail: state.otherDetails.value,
                stateId: state.state.value,
            }
            if (props.data) {
                model.id = props.data.ID
            }
            props.onSubmit(model)
        }
    }
    return (
        <React.Fragment>
            <h4 className="card-title mb-4">{props.title}</h4>
            <div id="basic-example">
                <section>
                    <form onSubmit={onSubmit}>
                        <div className="row">
                            <div className="col-lg-4">
                                <div className="mb-3">
                                    <label htmlFor="basicpill-country-input">
                                        Choose Country <span className='text-danger'>*</span>
                                    </label>
                                    <select
                                        className={state.country.error ? "form-select is-invalid" : "form-select"}
                                        id="basicpill-country-input"
                                        name={state.country.name}
                                        value={state.country.value}
                                        onChange={onChange}
                                    >
                                        <option value={''}>Choose Country</option>
                                        {state.country.options.map((item) => {
                                            return (
                                                <option value={item.ID}>{item.NAME}</option>
                                            )
                                        })}
                                    </select>
                                </div>
                            </div>
                            <div className="col-lg-4">
                                <div className="mb-3">
                                    <label htmlFor="basicpill-firstname-input">
                                        Choose State <span className='text-danger'>*</span>
                                    </label>
                                    <select
                                        className={state.state.error ? "form-select is-invalid" : "form-select"}
                                        id="basicpill-firstname-input"
                                        name={state.state.name}
                                        value={state.state.value}
                                        onChange={onChange}
                                    >
                                        <option value={''}>Choose State</option>
                                        {state.state.options.map((item) => {
                                            return (
                                                <option value={item.ID}>{item.NAME}</option>
                                            )
                                        })}
                                    </select>
                                </div>
                            </div>

                            <div className="col-lg-4">
                                <div className="mb-3">
                                    <label htmlFor="basicpill-firstname-input">
                                        District Name <span className='text-danger'>*</span>
                                    </label>
                                    <input
                                        type="text"
                                        className={state.name.error ? "form-control is-invalid" : "form-control"}

                                        id="basicpill-firstname-input"
                                        placeholder="Enter State Name"
                                        name={state.name.name}
                                        value={state.name.value}
                                        onChange={onChange}
                                    />
                                </div>
                            </div>

                            <div className="col-lg-12">
                                <div className="mb-3">
                                    <label htmlFor="basicpill-address-input">
                                        Other Details
                                    </label>
                                    <textarea
                                        id="basicpill-address-input"
                                        className={state.otherDetails.error ? "form-control is-invalid" : "form-control"}

                                        rows={2}
                                        placeholder="Enter Other Details"
                                        defaultValue={""}
                                        name={state.otherDetails.name}
                                        value={state.otherDetails.value}
                                        onChange={onChange}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-6">
                                <div className="mb-3">
                                    <button
                                        type='submit'
                                        className="btn btn-success waves-effect btn-label waves-light me-2"
                                    >
                                        <i className="bx bx-check-double label-icon" />{" "}
                                        {props.buttonName}
                                    </button>
                                    <button
                                        type='reset'
                                        className="btn btn-danger waves-effect btn-label waves-light"
                                        onClick={() => window.history.back()}
                                    >
                                        <i className="bx bx-block label-icon " /> Cancel
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                </section>
            </div>
        </React.Fragment>

    )
}

export default Form